(()=>{
function init(root){
 if(root.dataset.chitsReady)return;
 root.dataset.chitsReady='true';
 function syncLabels(){root.querySelectorAll('.swatch').forEach(group=>{const checked=group.querySelector('input:checked');const label=group.querySelector('.variant_current');if(checked&&label)label.textContent=checked.value;});}
 syncLabels();
 root.addEventListener('change',()=>setTimeout(syncLabels,0));
 const notes=root.querySelector('.chits-notes');
 const form=root.querySelector('form.product-form');
 if(notes&&form){
  const summary=notes.querySelector('summary');
  const normalLabel=summary.textContent;
  const nameOptions=[...root.querySelectorAll('.swatch')].filter(e=>/custom name|personali[sz]/i.test(e.querySelector('.header')?.textContent||''));
  function personalisation(){
   const title=root.querySelector('meta[itemprop=name]')?.content||'';
   const needed=nameOptions.length?nameOptions.some(e=>/^yes$/i.test(e.querySelector('input:checked')?.value||'')):/customis|customiz|personali[sz]/i.test(title);
   if(needed){const quantity=form.querySelector('.group-quantity');if(quantity)quantity.before(notes);summary.textContent=root.dataset.personalLabel;notes.open=true;}
   else{form.append(notes);summary.textContent=normalLabel;notes.open=false;}
  }
  personalisation();
  nameOptions.forEach(e=>e.addEventListener('change',()=>setTimeout(personalisation,0)));
 }
 root.querySelectorAll('.swatch_size').forEach(original=>{
  const inputs=[...original.querySelectorAll('input[type=radio]')];
  const entries=inputs.map(input=>{const match=input.value.match(/^(.+?)\s+-\s+(Lightweight|Heavyweight)$/i);return match?{input,size:match[1],weight:match[2]}:null});
  if(!entries.length||entries.some(e=>!e))return;
  const weights=[...new Set(entries.map(e=>e.weight))];
  if(weights.length<2)return;
  const sizes=[...new Set(entries.map(e=>e.size))];
  const box=document.createElement('div');box.className='chits-options';
  const groups={};
  for(const [key,values,label] of [['weight',weights,root.dataset.weightLabel],['size',sizes,root.dataset.sizeLabel]]){
   const field=document.createElement('fieldset'),legend=document.createElement('legend'),buttons=document.createElement('div');
   legend.textContent=label;buttons.className='chits-buttons';field.append(legend,buttons);box.append(field);groups[key]=[];
   values.forEach(value=>{const b=document.createElement('button');b.type='button';b.textContent=value;b.dataset.value=value;b.setAttribute('aria-pressed','false');buttons.append(b);groups[key].push(b);b.addEventListener('click',()=>choose(key,value))});
  }
  original.before(box);original.classList.add('chits-original-options');
  const index=Number(original.dataset.optionIndex);
  const select=root.querySelector('#productSelect');
  let state={weight:weights[0],size:sizes[0]};
  function selected(){return entries.find(e=>e.input.checked)||entries.find(e=>e.input.value===root.querySelectorAll('.single-option-selector')[index]?.value)||entries[0]}
  function allowed(e){return !e.input.disabled&&!e.input.closest('.swatch-element').classList.contains('soldout')}
  function sync(){const e=selected();state={weight:e.weight,size:e.size};for(const key of ['weight','size'])groups[key].forEach(b=>{b.setAttribute('aria-pressed',String(state[key]===b.dataset.value));b.disabled=key==='weight'?!entries.some(e=>e.weight===b.dataset.value&&allowed(e)):!entries.some(e=>e.weight===state.weight&&e.size===b.dataset.value&&allowed(e))})}
  function choose(key,value){const wanted={...state,[key]:value};let target=entries.find(e=>e.size===wanted.size&&e.weight===wanted.weight&&allowed(e));if(!target&&key==='weight')target=entries.find(e=>e.weight===value&&allowed(e));if(!target)return;target.input.click();sync();}
  root.addEventListener('change',()=>setTimeout(sync,0));
  new MutationObserver(sync).observe(original,{subtree:true,attributes:true,attributeFilter:['class','disabled','checked']});
  if(select)new MutationObserver(sync).observe(select,{subtree:true,attributes:true,attributeFilter:['selected']});
  sync();
 });
}
function start(){document.querySelectorAll('.chits-product').forEach(init)}
if(document.readyState==='complete')start();else window.addEventListener('load',start,{once:true});
document.addEventListener('shopify:section:load',start);
})();
